import recruiterApi from "api/recruiter";
import Modal from "components/Modal";
import ModalLayout from "components/ModalLayout";
import Selector from "components/Selector";
import {handleError} from "helpers/errors";
import {AwaitableModal} from "hooks/useAwaitableModal";
import {useState} from "react";

interface Props {
  name: string;
  type: string;
}

const EditProfile: AwaitableModal<Props, Props> = ({initialData, open, onCancel, resolve}) => {
  const [name, setName] = useState(initialData.name);
  const [type, setType] = useState<string>(initialData.type);
  const [submitting, setSubmitting] = useState(false);

  const onEdit = () => {
    if (submitting) return;
    if (!name) return handleError("Please enter your name");
    if (!type) return handleError("Please select your recruiter type");
    setSubmitting(true);
    recruiterApi
      .updateProfile({name, type})
      .then(() => resolve({name, type}))
      .finally(() => setSubmitting(false));
  };

  return (
    <Modal open={open} close={!submitting ? onCancel : () => {}}>
      <ModalLayout
        title="Edit Profile"
        footer={
          <>
            <button className="btn-secondary" disabled={submitting} onClick={onCancel}>
              Cancel
            </button>
            <button className="btn-primary" disabled={submitting} onClick={onEdit}>
              Save Changes
            </button>
          </>
        }
      >
        <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.currentTarget.value)} />
        <Selector value={type || "Type"}>
          <div
            onClick={() => setType("Recruiter")}
            className="px-4 py-3 text-sm text-brand-navy cursor-pointer select-none hover:bg-brand-cream"
          >
            Recruiter
          </div>
        </Selector>
      </ModalLayout>
    </Modal>
  );
};

export default EditProfile;
